module.exports = __webpack_public_path__ + "media/images/app/colors/colors-green-955c0c3d90f76c0c3e7977bab233ea18.webp";